/** Dashboard wording in Arabic (default, right-to-left) and English. One key per idea. */
export type Language = 'ar' | 'en';

const ar = {
  navOverview: 'الملخص',
  navProposals: 'الاقتراحات',
  navBranches: 'الفروع',
  navSettings: 'الإعدادات',
  navHealth: 'حالة النظام',
  signOut: 'تسجيل الخروج',
  switchLanguage: 'English',

  loginTitle: 'ادخل بإيميلك',
  loginHint: 'بنبعتلك رابط دخول. الدخول بس للحسابات اللي ضافها المالك.',
  email: 'الإيميل',
  sendLink: 'ابعت رابط الدخول',
  linkSent: 'بعتنا الرابط. افتح إيميلك واضغط عليه من نفس الجهاز.',
  loginFailed: 'ما قدرنا نبعت الرابط. تأكد من الإيميل أو اطلب من المالك يضيفك.',
  noAccess: 'حسابك مش مفعّل بالنظام. اطلب من المالك يضيفك.',

  loading: 'جاري التحميل…',
  loadFailed: 'ما قدرنا نجيب البيانات. حدّث الصفحة، وإذا تكرر شوف صفحة حالة النظام.',
  retry: 'حاول مرة ثانية',

  stopOn: 'الإيقاف الطارئ شغّال: البوت ما بيغيّر أي شي عند جوجل.',
  stopOff: 'البوت شغّال ضمن السقف والموافقات.',
  stopRelease: 'شغّل البوت',
  stopEngage: 'أوقف كل شي فوراً',
  stopConfirmRelease: 'متأكد؟ البوت رح يقدر ينفّذ الاقتراحات اللي توافق عليها.',

  monthSpend: 'صرف الشهر',
  ofCap: 'من سقف',
  capNotSet: 'السقف الشهري مش محدد. ما في أي حملة بتنطلق قبل ما تحدده من الإعدادات.',
  capOnPlan: 'ماشي حسب الخطة',
  capAhead: 'الصرف أسرع من الخطة',
  capReached: 'وصلنا السقف، الحملات لازم توقف',
  planMarker: 'وين لازم نكون اليوم',
  yesterday: 'أمس',
  spend: 'الصرف',
  calls: 'اتصالات',
  directions: 'طلبات اتجاهات',
  visits: 'زيارات (تقدير جوجل)',
  noDeliveryYesterday: 'ما في إعلانات ظهرت أمس.',
  waitingForYou: 'بانتظار قرارك',
  openProposals: 'افتح الاقتراحات',
  openAlerts: 'تنبيهات مفتوحة',
  noAlerts: 'ما في تنبيهات مفتوحة.',
  since: 'من',

  proposalsPending: 'بانتظار قرارك',
  proposalsApproved: 'معتمدة وبانتظار التنفيذ',
  proposalsHistory: 'السابقة',
  noPending: 'ما في اقتراحات بانتظارك.',
  noHistory: 'لسا ما في اقتراحات سابقة.',
  projected: 'صرف الشهر المتوقع بعد التنفيذ',
  expires: 'بينتهي',
  why: 'ليش',
  approve: 'موافقة',
  reject: 'رفض',
  withdrawApproval: 'سحب الموافقة',
  withdrawHint: 'معتمد وما تنفّذ لسا. السحب بيحرّر مكانه تحت السقف وما بيتنفّذ.',
  withdrawFailed: 'ما انسحبت الموافقة: يمكن بلّش تنفيذه أو انلغى.',
  notePlaceholder: 'ملاحظة (اختياري)',
  decided: 'تم تسجيل قرارك.',
  decideFailed: 'ما انسجل القرار: يمكن انحسم من جهاز ثاني أو انتهت مدته.',
  viewerCannotDecide: 'القرار للمالك بس.',
  propApproved: 'تمت الموافقة',
  propApplying: 'قيد التنفيذ',
  propRejected: 'مرفوض',
  propExpired: 'انتهت مدته',
  propApplied: 'تنفّذ',
  propFailed: 'فشل التنفيذ',
  propSuperseded: 'استُبدل باقتراح أحدث',
  propPending: 'بانتظار',

  branchName: 'الفرع',
  city: 'المدينة',
  phone: 'الرقم',
  tracking: 'القياس',
  callsTracked: 'الاتصالات',
  directionsTracked: 'الاتجاهات',
  adsAllowed: 'الإعلانات',
  allowed: 'مسموحة',
  notYet: 'لسا',
  openingSoon: 'بيفتح قريباً',
  closed: 'مسكّر',
  branchesNote:
    'ما في إعلان لأي فرع قبل ما يتأكد قياس الاتصالات والاتجاهات تبعه، حتى نعرف شو رجّع كل درهم.',

  monthlyCap: 'السقف الشهري للإعلانات (درهم)',
  monthlyCapHelp: 'البوت ما بيتجاوزه أبداً. بينغيّر بس ما بينمسح.',
  adLanguage: 'لغة الإعلانات',
  langAr: 'عربي',
  langEn: 'إنجليزي',
  langBoth: 'الاثنين',
  langBot: 'البوت يقرر (ويشرح السبب)',
  reportLanguage: 'لغة الرسائل والتقارير',
  brandSearch: 'حملة البحث باسم المطعم',
  webSearch: 'المساعد بيبحث على الإنترنت',
  webSearchHint:
    'المنافسين وتحديثات جوجل: لحد 3 بحثات للجواب، كل بحث 0.01 دولار ومحسوب من سقف الذكاء الاصطناعي.',
  on: 'شغّالة',
  off: 'متوقفة',
  summaryFrequency: 'الملخص على تيليجرام',
  freqDaily: 'يومي',
  freqDailyEvening: 'يومي + مسائي',
  freqWeekly: 'أسبوعي',
  freqOff: 'إيقاف',
  summaryTime: 'وقت الملخص',
  eveningTime: 'وقت الملخص المسائي',
  summaryDays: 'أيام الملخص',
  weeklyDay: 'يوم الملخص الأسبوعي',
  aiBudget: 'حد صرف الذكاء الاصطناعي الشهري (دولار)',
  aiBudgetHelp: 'بدونه البوت ما بيستخدم الذكاء الاصطناعي أبداً.',
  save: 'احفظ التغييرات',
  saved: 'انحفظت التغييرات.',
  saveFailed: 'ما انحفظت: تأكد من القيم (مثلاً المسائي لازم يكون بعد الصباحي).',
  nothingChanged: 'ما غيّرت شي.',
  invalidAmount: 'اكتب مبلغ صحيح أكبر من صفر.',
  ownerOnlySettings: 'تغيير الإعدادات للمالك بس.',
  history: 'آخر التغييرات',
  noChanges: 'لسا ما في تغييرات.',

  jobs: 'المهام الدورية',
  lastRun: 'آخر تشغيل',
  neverRan: 'ما اشتغلت لسا',
  statusSucceeded: 'نجحت',
  statusSkipped: 'تخطّت (مش مربوطة لسا)',
  statusFailed: 'فشلت',
  statusRunning: 'شغّالة',
  jobGoogleSync: 'سحب الأداء من جوجل',
  jobAlerts: 'فحص التنبيهات',
  jobSummary: 'ملخص تيليجرام',
  jobHousekeeping: 'تنظيف الاقتراحات المنتهية',
  jobWatchdog: 'الحارس (فحص + إرسال فوري)',
  jobTelegramSetup: 'ربط تيليجرام',
  jobMonthlyReport: 'التقرير الشهري من المساعد',
  jobKeysCheck: 'فحص المفاتيح',
  keysTitle: 'المفاتيح (آخر فحص)',
  keyAnthropic: 'Claude',
  keyTelegram: 'تيليجرام',
  keyGoogleAds: 'Google Ads',
  keyAppOrigin: 'رابط التطبيق (APP_ORIGIN)',
  keyAiBudget: 'ميزانية الذكاء الاصطناعي',
  keyOk: 'شغال',
  keyMissing: 'مش محطوط',
  keyInvalid: 'شكله غلط',
  keyRejected: 'مرفوض',
  keyUnreachable: 'ما رد، بنجرّب كمان ساعة',
  keySet: 'محطوطة',
  aiSpend: 'صرف الذكاء الاصطناعي هالشهر',
  aiBudgetNotSet: 'الحد مش محدد',
  errors: 'آخر الأخطاء',
  noErrors: 'ما في أخطاء مسجّلة.',
  ownerOnlyHealth: 'حالة النظام للمالك بس.',

  navChat: 'المساعد',
  navMemory: 'الذاكرة',
  navMore: 'المزيد',

  chatNew: 'محادثة جديدة',
  chatHistory: 'المحادثات السابقة',
  chatNoHistory: 'لسا ما في محادثات.',
  chatWelcomeTitle: 'أهلاً، أنا مدير التسويق تبعك.',
  chatWelcomeText:
    'اسألني عن أداء الحملات والفروع، أو خلينا نخطط لحملة. أي تغيير بالصرف بيوصلك كاقتراح، وما بيتنفذ إلا بموافقتك.',
  chatSuggest1: 'ليش الاتصالات قلّت بالشامخة هالأسبوع؟',
  chatSuggest2: 'رتّبلي الفروع من الأقوى للأضعف هالشهر.',
  chatSuggest3: 'كيف بتوزّع 600 درهم باليوم على الفروع؟',
  chatSuggest4: 'اكتبلي 3 نصوص إعلان لعرض رمضان.',
  chatPlaceholder: 'اكتب سؤالك…',
  chatSend: 'إرسال',
  chatMicStart: 'اسأل بالصوت',
  chatMicStop: 'وقّف التسجيل',
  chatListening: 'عم بسمعك… احكي وبعدين اضغط وقّف.',
  chatVoiceUnsupported: 'المتصفح ما بيدعم الإدخال بالصوت هون؛ اكتب سؤالك.',
  chatVoiceDenied: 'ما في إذن للمايكروفون. فعّله من الإعدادات أو اكتب سؤالك.',
  chatSpeakOn: 'الرد المسموع شغّال',
  chatSpeakOff: 'شغّل الرد المسموع',
  chatThinking: 'عم يفكّر…',
  chatTrial: 'بيانات تجريبية: الأرقام للتجربة لحد ما نربط حساب الإعلانات الحقيقي.',
  chatTrialShort: 'بيانات تجريبية',
  branchTrialBoth:
    'بيانات تجريبية: أرقام الإعلانات والتقييمات للتجربة لحد ما ينربط حساب الإعلانات الحقيقي ونوصّل المراجعات الحقيقية.',
  branchTrialAds: 'بيانات تجريبية: أرقام الإعلانات للتجربة لحد ما ينربط حساب الإعلانات الحقيقي.',
  branchTrialReviews:
    'بيانات تجريبية بالتقييمات بس: أرقام الإعلانات حقيقية، والتقييمات والمراجعات للتجربة لحد ما نوصّل المراجعات الحقيقية.',
  chatTrialReviews:
    'بيانات تجريبية بالتقييمات بس: أرقام الإعلانات حقيقية، والتقييمات والمراجعات للتجربة لحد ما نوصّل المراجعات الحقيقية.',
  chatViaVoice: 'بالصوت',
  privacyTitle: 'الخصوصية',
  privacyVoice:
    'السؤال بالصوت بيستعمل خدمة تحويل الكلام لنص تبع المتصفح نفسه، مش خدمتنا: على كروم الصوت بينبعت لخوادم جوجل، وعلى سفاري لأبل (إلا إذا الجهاز بيحوّله محلياً). ما بنخزّن الصوت، بس النص اللي بيطلع. إذا ما بدك صوتك يطلع من الجهاز، اكتب سؤالك.',
  privacySpeech: 'الرد المسموع بيتقرأ على جهازك بصوت المتصفح؛ ما بينبعت لأي مكان.',
  chatErrNotConfigured: 'المساعد مش مفعّل لسا: ناقص مفتاح Claude وأسعاره.',
  chatErrBudget: 'حد صرف الذكاء الاصطناعي مش محدد أو خلص لهالشهر. شوف الإعدادات.',
  chatErrNotOwner: 'المساعد للمالك بس.',
  chatErrGeneric: 'ما قدر المساعد يرد. جرّب كمان شوي؛ الخطأ انسجّل.',
  chatErrNetwork: 'ما في اتصال. تأكد من الإنترنت وجرّب مرة ثانية.',
  chatRetry: 'أعد الإرسال',
  chatOwnerOnly: 'المحادثة مع المساعد للمالك بس.',

  cardProposal: 'اقتراح',
  cardTrialNotApprovable: 'مبني على بيانات تجريبية: للنقاش بس، ما بينفع ينعتمد.',
  cardProjected: 'صرف الشهر المتوقع',
  cardCap: 'السقف',
  cardAutoApproved: 'اعتمدته مرحلة الثقة الحالية',
  cardWaiting: 'بانتظار موافقتك',
  cardCommentary: 'شرح المساعد',
  figBranchDaily: 'ميزانية يومية',
  figBranches: 'الفروع',
  figDailyChange: 'التغيير باليوم',
  figMonthChange: 'التغيير لباقي الشهر',
  figHeadroom: 'الباقي تحت السقف',
  figUnavailable: 'أرقام الاقتراح مش مكتملة، فما بينفع ينعتمد من هون.',
  propCancelled: 'انلغى قبل التنفيذ',
  cancelEmergency: 'انلغى لأنك شغّلت إيقاف الطوارئ.',
  cancelStageLowered: 'انلغى لأن مرحلة الثقة الحالية ما بتسمح فيه.',
  cancelOwnerWithdrew: 'انلغى لأنك سحبت الموافقة.',
  decideOverCap: 'ما انعتمد: مع الاقتراحات المعتمدة قبله بيتجاوز سقف الشهر.',
  decideCapNotSet: 'ما انعتمد: حدّد سقف الإعلانات الشهري بالإعدادات أول.',
  decideBranchNotCleared: 'ما انعتمد: في فرع بالاقتراح مش مفعّل للإعلانات.',
  kindLaunch: 'إطلاق حملة',
  kindBudgetChange: 'تغيير ميزانية',
  kindPause: 'إيقاف مؤقت',
  kindResume: 'إعادة تشغيل',
  kindCreativeUpdate: 'تعديل نصوص',
  kindNegativeKeywords: 'كلمات مستبعدة',
  kindLanguageChange: 'تغيير لغة الإعلان',
  cardDecision: 'قرار للحفظ',
  cardReason: 'السبب',
  cardSaveDecision: 'احفظ القرار',
  cardDecisionSaved: 'انحفظ القرار بالذاكرة.',
  cardSaveFailed: 'ما انحفظ. جرّب مرة ثانية.',
  cardLesson: 'تقرير درس (مسودة)',
  cardOpenLesson: 'راجعه واعتمده بالذاكرة',
  outcomeMet: 'تحقق الهدف',
  outcomePartly: 'تحقق جزئياً',
  outcomeMissed: 'ما تحقق',

  memoryDecisions: 'سجل القرارات',
  memoryNoDecisions: 'لسا ما في قرارات.',
  memoryLessons: 'دروس الحملات',
  memoryNoLessons:
    'لسا ما في دروس. بعد أول حملة حقيقية، المساعد بيكتب تقرير الدرس وانت بتراجعه وبتعتمده.',
  memorySourceProposal: 'قرار على اقتراح',
  memorySourceStage: 'اعتمدته مرحلة الثقة',
  memorySourceOwner: 'قرار محفوظ',
  lessonGoal: 'الهدف',
  lessonResult: 'النتيجة',
  lessonWorked: 'شو نجح',
  lessonFailed: 'شو فشل',
  lessonChange: 'شو بنغيّر المرة الجاية',
  lessonDraft: 'مسودة',
  lessonFinal: 'معتمد',
  lessonFinalize: 'اعتمد الدرس',
  lessonFinalized: 'انعتمد الدرس.',
  lessonFinalizeFailed: 'ما انعتمد. جرّب مرة ثانية.',

  trustTitle: 'مراحل الثقة',
  trustHelp:
    'المساعد بيكسب الاستقلالية تدريجياً، وانت بتنقله من مرحلة لمرحلة. بكل المراحل: السقف الشهري ما بيتجاوز، وكل قرار مسجّل، وزر الإيقاف الطارئ شغّال.',
  trust1: 'البداية: كل إطلاق وكل تعديل بموافقتك.',
  trust2:
    'بعد نتائج مثبتة: تعديل النصوص ونقل الميزانية بين الفروع تلقائي؛ الحملة الجديدة وزيادة الصرف بموافقتك.',
  trust3: 'استقلال: إطلاق حملات كاملة ضمن السقف تلقائي؛ تغيير السقف بإيدك بس.',
  trustConfirm: 'متأكد بدك تنقل المساعد لهالمرحلة؟',
  trustChanged: 'انتقل المساعد للمرحلة الجديدة.',
  trustFailed: 'ما تغيّرت المرحلة.',
  stage2Shift: 'أقصى نسبة نقل ميزانية تلقائي بالمرحلة 2 (%)',
  stage2ShiftHelp: '0 يعني ولا نقل بدون موافقتك. الحد الأعلى 30%.',
  invalidPercent: 'اكتب رقم صحيح من 0 لـ 30.',

  moreTitle: 'المزيد',

  rankingTitle: 'ترتيب الفروع',
  rankingHelp:
    'من الأقوى للأضعف: تكلفة الاتصال أو طلب الاتجاهات، عدد النتائج، والتقييم. السبب مكتوب تحت كل فرع.',
  rankingPeriod: 'الفترة',
  periodLast7: 'آخر 7 أيام',
  periodLast28: 'آخر 28 يوم',
  periodLastMonth: 'الشهر الماضي',
  rankingScore: 'النقاط من 100',
  rankingResults: 'اتصالات + اتجاهات',
  rankingCost: 'تكلفة النتيجة',
  rankingTrend: 'مقارنة بالفترة اللي قبلها',
  rankingRating: 'التقييم',
  rankingNoScore: 'أرقام مش كفاية',
  trackingTitle: 'القياس والسماح بالإعلان',
  competitorTitle: 'دراسة المنافسين حول كل فرع',
  competitorNote:
    'مسودة من مصادر عامة، كل معلومة مع رابطها. راجع كل مطعم: منافس مباشر ولا لا، أو استبعده إذا مش بمحله. المساعد بيعتمد على مراجعتك.',
  competitorEmpty: 'لسا ما في دراسة منافسين محمّلة.',
  competitorToReview: 'بانتظار مراجعتك',
  competitorAllReviewed: 'كله مراجَع',
  competitorNotReviewed: 'مسودة',
  competitorDirect: 'منافس مباشر',
  competitorNotDirect: 'مش منافس مباشر',
  competitorUndecided: 'مراجَع',
  competitorRejected: 'مستبعد',
  competitorNewSinceReview: 'في معلومة جديدة بعد مراجعتك',
  competitorMarkDirect: 'منافس مباشر',
  competitorMarkNotDirect: 'مش مباشر',
  competitorMarkReject: 'استبعد',
  competitorReviewFailed: 'ما انحفظت المراجعة. جرّب كمان مرة.',
  competitorSource: 'المصدر',
  competitorCuisine: 'المطبخ',
  competitorAddress: 'العنوان',
  competitorRating: 'التقييم',
  competitorReviews: 'المراجعات',
  competitorPrice: 'الأسعار',
  competitorDelivery: 'التوصيل',
  competitorHours: 'الدوام',
  competitorOther: 'غير ذلك',
  reasonNotAdvertisable: 'ما بينعلن له (مطبخ مركزي أو مسكّر)',
  reasonTrackingNotVerified: 'قياس الاتصالات والاتجاهات لسا مش متأكد',
  reasonAdsNotEnabled: 'القياس جاهز، بس الفرع لسا مش مفعّل للإعلانات',
  reasonNoAdsYet: 'لسا ما في إعلانات',
  reasonNotEnoughData: 'أرقام قليلة لسا',
  reasonCheap: 'نتائج أرخص من المعدل',
  reasonExpensive: 'نتائج أغلى من المعدل',
  reasonFalling: 'النتائج نازلة',
  reasonRising: 'النتائج طالعة',
  reasonViewsNoDirections: 'بيشوفوه كثير بس طلبات الاتجاهات قليلة (غالباً الصور أو العرض)',
  reasonServiceIssue: 'شكاوى تأخير أو خدمة: لا نزيد الإعلان قبل الحل',
  reasonLowRating: 'التقييم أقل من 4',

  cardAdCopy: 'نصوص إعلان مطابقة لشروط جوجل',
  cardBrief: 'بريف صور لفريق التصميم',
  copyText: 'انسخ',
  copied: 'انتسخ.',
  copyFailed: 'ما قدرت أنسخ؛ حدّد النص وانسخه بإيدك.',
} as const;

export type MessageKey = keyof typeof ar;

const en: Record<MessageKey, string> = {
  navOverview: 'Overview',
  navProposals: 'Proposals',
  navBranches: 'Branches',
  navSettings: 'Settings',
  navHealth: 'System health',
  signOut: 'Sign out',
  switchLanguage: 'عربي',

  loginTitle: 'Sign in with your email',
  loginHint: 'We will email you a sign-in link. Only accounts the owner added can sign in.',
  email: 'Email',
  sendLink: 'Email me a sign-in link',
  linkSent: 'Link sent. Open it from your email on this device.',
  loginFailed: 'The link could not be sent. Check the address or ask the owner to add you.',
  noAccess: 'Your account is not active here. Ask the owner to add you.',

  loading: 'Loading…',
  loadFailed: 'The data could not be loaded. Refresh; if it keeps happening, check System health.',
  retry: 'Try again',

  stopOn: 'Emergency stop is on: the bot changes nothing at Google.',
  stopOff: 'The bot is running within the cap and your approvals.',
  stopRelease: 'Start the bot',
  stopEngage: 'Stop everything now',
  stopConfirmRelease: 'Start the bot? It will be able to carry out proposals you approve.',

  monthSpend: 'Month spend',
  ofCap: 'of',
  capNotSet: 'No monthly cap yet. No campaign can launch until you set one in Settings.',
  capOnPlan: 'On plan',
  capAhead: 'Spending faster than plan',
  capReached: 'Cap reached; campaigns must stop',
  planMarker: 'Where the plan is today',
  yesterday: 'Yesterday',
  spend: 'Spend',
  calls: 'Calls',
  directions: 'Direction requests',
  visits: 'Store visits (Google estimate)',
  noDeliveryYesterday: 'No ads ran yesterday.',
  waitingForYou: 'Waiting for your decision',
  openProposals: 'Open proposals',
  openAlerts: 'Open alerts',
  noAlerts: 'No open alerts.',
  since: 'since',

  proposalsPending: 'Waiting for your decision',
  proposalsApproved: 'Approved, waiting to be applied',
  proposalsHistory: 'Earlier',
  noPending: 'Nothing is waiting for you.',
  noHistory: 'No earlier proposals yet.',
  projected: 'Projected month spend after this change',
  expires: 'Expires',
  why: 'Why',
  approve: 'Approve',
  reject: 'Reject',
  withdrawApproval: 'Withdraw approval',
  withdrawHint:
    'Approved and not applied yet. Withdrawing frees its room under the cap; it is never applied.',
  withdrawFailed: 'Not withdrawn: it may have started applying or been cancelled.',
  notePlaceholder: 'Note (optional)',
  decided: 'Decision recorded.',
  decideFailed: 'Not recorded: it may have been decided on another device or expired.',
  viewerCannotDecide: 'Only the owner can decide.',
  propApproved: 'Approved',
  propApplying: 'Being applied',
  propRejected: 'Rejected',
  propExpired: 'Expired',
  propApplied: 'Applied',
  propFailed: 'Failed to apply',
  propSuperseded: 'Replaced by a newer proposal',
  propPending: 'Pending',

  branchName: 'Branch',
  city: 'City',
  phone: 'Phone',
  tracking: 'Tracking',
  callsTracked: 'Calls',
  directionsTracked: 'Directions',
  adsAllowed: 'Ads',
  allowed: 'Allowed',
  notYet: 'Not yet',
  openingSoon: 'Opening soon',
  closed: 'Closed',
  branchesNote:
    'No branch is advertised until its call and direction tracking is verified, so every dirham can be traced to results.',

  monthlyCap: 'Monthly ad cap (AED)',
  monthlyCapHelp: 'The bot never exceeds it. It can be changed, not removed.',
  adLanguage: 'Ad language',
  langAr: 'Arabic',
  langEn: 'English',
  langBoth: 'Both',
  langBot: 'Bot decides (and explains why)',
  reportLanguage: 'Messages and reports language',
  brandSearch: 'Search campaign for the restaurant name',
  webSearch: 'The assistant searches the web',
  webSearchHint:
    'Competitors and Google updates: up to 3 searches per answer, USD 0.01 each, counted against the AI cap.',
  on: 'On',
  off: 'Off',
  summaryFrequency: 'Telegram summary',
  freqDaily: 'Daily',
  freqDailyEvening: 'Daily + evening',
  freqWeekly: 'Weekly',
  freqOff: 'Off',
  summaryTime: 'Summary time',
  eveningTime: 'Evening summary time',
  summaryDays: 'Summary days',
  weeklyDay: 'Weekly summary day',
  aiBudget: 'Monthly AI spend limit (USD)',
  aiBudgetHelp: 'Without it the bot never uses AI.',
  save: 'Save changes',
  saved: 'Changes saved.',
  saveFailed: 'Not saved: check the values (for example, evening must be after morning).',
  nothingChanged: 'Nothing changed.',
  invalidAmount: 'Enter an amount greater than zero.',
  ownerOnlySettings: 'Only the owner can change settings.',
  history: 'Recent changes',
  noChanges: 'No changes yet.',

  jobs: 'Scheduled jobs',
  lastRun: 'Last run',
  neverRan: 'Has not run yet',
  statusSucceeded: 'Succeeded',
  statusSkipped: 'Skipped (not connected yet)',
  statusFailed: 'Failed',
  statusRunning: 'Running',
  jobGoogleSync: 'Fetch performance from Google',
  jobAlerts: 'Check alerts',
  jobSummary: 'Telegram summary',
  jobHousekeeping: 'Expire old proposals',
  jobWatchdog: 'Watchdog (self-check + instant messages)',
  jobTelegramSetup: 'Connect Telegram',
  jobMonthlyReport: 'Monthly report by the assistant',
  jobKeysCheck: 'Keys check',
  keysTitle: 'Keys (latest check)',
  keyAnthropic: 'Claude',
  keyTelegram: 'Telegram',
  keyGoogleAds: 'Google Ads',
  keyAppOrigin: 'App address (APP_ORIGIN)',
  keyAiBudget: 'AI budget',
  keyOk: 'Working',
  keyMissing: 'Not set',
  keyInvalid: 'Wrong format',
  keyRejected: 'Refused',
  keyUnreachable: 'No answer; tried again in an hour',
  keySet: 'Set',
  aiSpend: 'AI spend this month',
  aiBudgetNotSet: 'No limit set',
  errors: 'Recent errors',
  noErrors: 'No errors recorded.',
  ownerOnlyHealth: 'System health is for the owner only.',

  navChat: 'Assistant',
  navMemory: 'Memory',
  navMore: 'More',

  chatNew: 'New conversation',
  chatHistory: 'Past conversations',
  chatNoHistory: 'No conversations yet.',
  chatWelcomeTitle: "Hi, I'm your marketing manager.",
  chatWelcomeText:
    'Ask me how campaigns and branches are doing, or let us plan a campaign. Any spend change reaches you as a proposal and only happens with your approval.',
  chatSuggest1: 'Why did calls drop at Al Shamkha this week?',
  chatSuggest2: 'Rank the branches from strongest to weakest this month.',
  chatSuggest3: 'How would you split AED 600 a day across the branches?',
  chatSuggest4: 'Write 3 ad texts for a Ramadan offer.',
  chatPlaceholder: 'Type your question…',
  chatSend: 'Send',
  chatMicStart: 'Ask by voice',
  chatMicStop: 'Stop recording',
  chatListening: 'Listening… speak, then tap stop.',
  chatVoiceUnsupported: "This browser can't take voice input here; type your question.",
  chatVoiceDenied: 'No microphone permission. Allow it in settings or type your question.',
  chatSpeakOn: 'Spoken replies on',
  chatSpeakOff: 'Turn on spoken replies',
  chatThinking: 'Thinking…',
  chatTrial: 'Trial data: numbers are for trying things out until the real ads account is linked.',
  chatTrialShort: 'Trial data',
  branchTrialBoth:
    'Trial data: ad numbers and ratings are for trying things out until the real ads account and the real reviews are connected.',
  branchTrialAds:
    'Trial data: ad numbers are for trying things out until the real ads account is linked.',
  branchTrialReviews:
    'Trial data in ratings only: ad numbers are real; ratings and reviews are for trying things out until the real reviews are connected.',
  chatTrialReviews:
    'Trial data in ratings only: ad numbers are real; ratings and reviews are for trying things out until the real reviews are connected.',
  chatViaVoice: 'by voice',
  privacyTitle: 'Privacy',
  privacyVoice:
    "Asking by voice uses the browser's own speech-to-text service, not ours: Chrome sends the audio to Google's servers and Safari to Apple's (unless the device transcribes on-device). We never store audio, only the resulting text. If you don't want your voice to leave the device, type your question.",
  privacySpeech:
    "Spoken replies are read on your device by the browser's voice; nothing is sent anywhere.",
  chatErrNotConfigured:
    'The assistant is not switched on yet: the Claude key and prices are missing.',
  chatErrBudget: 'The monthly AI limit is not set or used up. See settings.',
  chatErrNotOwner: 'The assistant is for the owner only.',
  chatErrGeneric: "The assistant couldn't answer. Try again shortly; the error was recorded.",
  chatErrNetwork: 'No connection. Check the internet and try again.',
  chatRetry: 'Send again',
  chatOwnerOnly: 'Chatting with the assistant is for the owner only.',

  cardProposal: 'Proposal',
  cardTrialNotApprovable: 'Built on trial data: for discussion only, it cannot be approved.',
  cardProjected: 'Projected month spend',
  cardCap: 'Cap',
  cardAutoApproved: 'Approved by the current trust stage',
  cardWaiting: 'Waiting for your approval',
  cardCommentary: "Assistant's note",
  figBranchDaily: 'Daily budget',
  figBranches: 'Branches',
  figDailyChange: 'Change per day',
  figMonthChange: 'Change for the rest of the month',
  figHeadroom: 'Left under the cap',
  figUnavailable: 'The figures of this proposal are incomplete, so it cannot be approved here.',
  propCancelled: 'Cancelled before it was applied',
  cancelEmergency: 'Cancelled because you turned the emergency stop on.',
  cancelStageLowered: 'Cancelled because the current trust stage does not allow it.',
  cancelOwnerWithdrew: 'Cancelled because you withdrew the approval.',
  decideOverCap:
    'Not approved: with the proposals approved before it, the month would pass the cap.',
  decideCapNotSet: 'Not approved: set the monthly ads cap in settings first.',
  decideBranchNotCleared: 'Not approved: a branch in it is not enabled for ads.',
  kindLaunch: 'Launch',
  kindBudgetChange: 'Budget change',
  kindPause: 'Pause',
  kindResume: 'Resume',
  kindCreativeUpdate: 'Text update',
  kindNegativeKeywords: 'Negative keywords',
  kindLanguageChange: 'Ad language change',
  cardDecision: 'Decision to save',
  cardReason: 'Reason',
  cardSaveDecision: 'Save decision',
  cardDecisionSaved: 'Decision saved to memory.',
  cardSaveFailed: 'Not saved. Try again.',
  cardLesson: 'Lesson report (draft)',
  cardOpenLesson: 'Review and finalise it in Memory',
  outcomeMet: 'Goal met',
  outcomePartly: 'Partly met',
  outcomeMissed: 'Missed',

  memoryDecisions: 'Decision log',
  memoryNoDecisions: 'No decisions yet.',
  memoryLessons: 'Campaign lessons',
  memoryNoLessons:
    'No lessons yet. After the first real campaign the assistant drafts its lesson report and you review and finalise it.',
  memorySourceProposal: 'Decision on a proposal',
  memorySourceStage: 'Approved by the trust stage',
  memorySourceOwner: 'Saved decision',
  lessonGoal: 'Goal',
  lessonResult: 'Result',
  lessonWorked: 'What worked',
  lessonFailed: 'What failed',
  lessonChange: 'What to change next time',
  lessonDraft: 'Draft',
  lessonFinal: 'Final',
  lessonFinalize: 'Finalise lesson',
  lessonFinalized: 'Lesson finalised.',
  lessonFinalizeFailed: 'Not finalised. Try again.',

  trustTitle: 'Trust stages',
  trustHelp:
    'The assistant earns independence step by step, and you move it between stages. At every stage the monthly cap holds, every decision is recorded and the emergency stop works.',
  trust1: 'Start: every launch and every change needs your approval.',
  trust2:
    'After proven results: text edits and budget moves between branches are automatic; new campaigns and higher spend need you.',
  trust3: 'Independent: full launches within the cap are automatic; only you change the cap.',
  trustConfirm: 'Move the assistant to this stage?',
  trustChanged: 'The assistant moved to the new stage.',
  trustFailed: 'The stage did not change.',
  stage2Shift: 'Largest automatic budget move at stage 2 (%)',
  stage2ShiftHelp: '0 means nothing moves without you. At most 30%.',
  invalidPercent: 'Enter a whole number from 0 to 30.',

  moreTitle: 'More',

  rankingTitle: 'Branch ranking',
  rankingHelp:
    'Strongest to weakest: cost per call or direction request, number of results, and rating. The reasons are under each branch.',
  rankingPeriod: 'Period',
  periodLast7: 'Last 7 days',
  periodLast28: 'Last 28 days',
  periodLastMonth: 'Last month',
  rankingScore: 'Score out of 100',
  rankingResults: 'Calls + directions',
  rankingCost: 'Cost per result',
  rankingTrend: 'Against the period before',
  rankingRating: 'Rating',
  rankingNoScore: 'Not enough numbers',
  trackingTitle: 'Tracking and ad clearance',
  competitorTitle: 'Competitors around each branch',
  competitorNote:
    'A draft from public sources, each fact with its link. Review each restaurant: a direct competitor or not, or leave it out if it does not belong. The assistant relies on your review.',
  competitorEmpty: 'No competitor study loaded yet.',
  competitorToReview: 'Waiting for your review',
  competitorAllReviewed: 'All reviewed',
  competitorNotReviewed: 'Draft',
  competitorDirect: 'Direct competitor',
  competitorNotDirect: 'Not a direct competitor',
  competitorUndecided: 'Reviewed',
  competitorRejected: 'Left out',
  competitorNewSinceReview: 'New fact since your review',
  competitorMarkDirect: 'Direct competitor',
  competitorMarkNotDirect: 'Not direct',
  competitorMarkReject: 'Leave out',
  competitorReviewFailed: 'The review was not saved. Try again.',
  competitorSource: 'Source',
  competitorCuisine: 'Cuisine',
  competitorAddress: 'Address',
  competitorRating: 'Rating',
  competitorReviews: 'Reviews',
  competitorPrice: 'Prices',
  competitorDelivery: 'Delivery',
  competitorHours: 'Hours',
  competitorOther: 'Other',
  reasonNotAdvertisable: 'Never advertised (central kitchen or closed)',
  reasonTrackingNotVerified: 'Call and direction tracking not verified yet',
  reasonAdsNotEnabled: 'Tracking is ready, but the branch is not enabled for ads yet',
  reasonNoAdsYet: 'No ads yet',
  reasonNotEnoughData: 'Too few numbers yet',
  reasonCheap: 'Results cheaper than average',
  reasonExpensive: 'Results more expensive than average',
  reasonFalling: 'Results falling',
  reasonRising: 'Results rising',
  reasonViewsNoDirections: 'Seen a lot but few direction requests (often the photos or the offer)',
  reasonServiceIssue: 'Delay or service complaints: no more ads until fixed',
  reasonLowRating: 'Rating below 4',

  cardAdCopy: "Ad texts that meet Google's limits",
  cardBrief: 'Photo brief for the design team',
  copyText: 'Copy',
  copied: 'Copied.',
  copyFailed: 'Could not copy; select the text and copy it by hand.',
};

export const MESSAGES: Record<Language, Record<MessageKey, string>> = { ar, en };

/** ISO weekday (1 = Monday … 7 = Sunday) names, Sunday-first order is a display concern. */
export const WEEKDAYS: Record<Language, readonly string[]> = {
  ar: ['الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت', 'الأحد'],
  en: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
};
